import { render } from "./MainLanding.vue?vue&type=template&id=cf1eaf34&ts=true"
import script from "./MainLanding.vue?vue&type=script&lang=ts"
export * from "./MainLanding.vue?vue&type=script&lang=ts"

import "@/styles/main-landing.css?vue&type=style&index=0&lang=css"
import "./MainLanding.vue?vue&type=style&index=1&id=cf1eaf34&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QBtn});
